import { gql } from '@apollo/client';

export const UPDATE_CALPUFF_CONFIGURATION = gql`
    mutation updateCalpuffConfiguration($id: ID!, $input: UpdateCalpuffConfigurationPatch!) {
        facility {
            modelConfigurations {
                calpuffConfigurations {
                    updateCalpuffConfiguration(id: $id, input: $input) {
                        id
                    }
                }
            }
        }
    }
`;
